var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_load)?_c('Editor',{ref:"editor",attrs:{"config":_vm.config}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }